var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13 16H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4v2H2v11h11v-4h2v4a2 2 0 0 1-2 2M7.7 9.707 6.29 8.293 12.583 2H9V0h7v7h-2V3.415z"
})));
export default SvgExternalLink;